import object from "lodash/object";
import { fetchRequest } from "../../utils/http.ts";
import { getAccessToken } from "../../utils/tokens";
import { logError } from "../../components/Errors/index";

import {
  getClientServiceUrl as clientServiceUrl,
  getHttpProtocol as scheme,
  fullAPIURL,
} from "../../utils/requests";

export const CLIENT_ERROR = "CLIENT_ERROR";
export const SET_CLIENT = "SET_CLIENT";
export const FETCH_CLIENT = "FETCH_CLIENT";
export const SET_STAFF = "SET_STAFF";
export const FETCH_FEATURES = "FETCH_FEATURES";
export const SET_FEATURES = "SET_FEATURES";
export const SET_CLIENT_TAXES = "SET_CLIENT_TAXES";
export const FETCH_CLIENT_TAXES = "FETCH_CLIENT_TAXES";

export function setClientError(err) {
  return {
    type: CLIENT_ERROR,
    error: err,
  };
}

export function setClient(client) {
  return {
    type: SET_CLIENT,
    client,
  };
}

export function setStaff(staff) {
  return {
    type: SET_STAFF,
    staff,
  };
}

export function setFeatures(features) {
  return {
    type: SET_FEATURES,
    features,
  };
}

export function setTaxes(taxes) {
  return {
    type: SET_CLIENT_TAXES,
    taxes,
  };
}

export function fetchClient(accessToken, subdomain) {
  const fetchClientUrl = `${scheme}//${clientServiceUrl}/clients/subdomain/${subdomain.toUpperCase()}`;

  return async function client(dispatch) {
    try {
      const response = await fetchRequest({
        path: fetchClientUrl,
        options: {
          token: accessToken,
        },
      });

      if (response.ok) {
        const body = await response.json();

        const { client } = body;

        dispatch(setClient(client));

        return client;
      }

      throw new Error(
        `Request returned with invalid status: ${response.status}`,
      );
    } catch (err) {
      logError({
        feature: FETCH_CLIENT,
        message: err.message,
        request: {
          method: "GET",
          path: fetchClientUrl,
        },
        client: subdomain,
      });
      return dispatch(setClientError(err));
    }
  };
}

export function getFeatures() {
  return async function clientFeatures(dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { data: client } = state.client;

    try {
      const response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/features`,
        options: {
          token,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      });

      if (response && response.ok) {
        const features = await response.json();

        return dispatch(setFeatures(features));
      }

      return dispatch(setFeatures({}));
    } catch (error) {
      console.error({ error });

      return dispatch(setFeatures({}));
    }
  };
}
export function getStaff() {
  return async function fetchStaff(dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { data: client } = state.client;

    try {
      const response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/staff`,
        options: {
          token,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      });

      if (response && response.ok) {
        const staff = await response.json();

        return dispatch(setStaff(staff.data));
      }

      return dispatch(setClient(new Error("Request Failed to Complete")));
    } catch (error) {
      console.error({ error });

      return dispatch(setClientError(error));
    }
  };
}

export function fetchClientTaxes() {
  return async function clientTaxes(dispatch, getState) {
    const token = getAccessToken();

    let response = null;

    const state = getState();

    const { data: client } = state.client;
    const fetchClientTaxesUrl = `${scheme}//${clientServiceUrl}/client/taxes/${object.get(
      client,
      "uuid",
    )}`;
    try {
      response = await fetchRequest({
        path: fetchClientTaxesUrl,
        options: {
          token,
        },
      });

      if (response.ok) {
        const body = await response.json();

        const { data } = body;

        return dispatch(setTaxes(data));
      }

      throw new Error(
        `Request returned with invalid status: ${response.status}`,
      );
    } catch (err) {
      logError({
        feature: FETCH_CLIENT_TAXES,
        message: err.message,
        request: {
          method: "GET",
          path: fetchClientTaxesUrl,
        },
        client: object.get(client, "uuid"),
      });
      return dispatch(setClientError(err));
    }
  };
}
